module.exports = "/images/ax.svg?4e3e8d7573a98db47e3c80a60daec4fc";